import request from "@/utils/request";
import { jsonHeaders } from "./api-header-conf.js";

export function getUserByWxId(wxId) {
  return request({
    headers: jsonHeaders,
    url: `/wxUser/${wxId}`,
    method: "get"
  });
}
